<div class="revocation__header row" id="revocationHeader">
  <div class="revocation__header-col col-12">
    <h3 class="revocation__intro"
        *appApplyIfNotEmpty="translationService.getTranslation('revocation_intro')"
        [innerHTML]="translationService.getTranslation('revocation_intro')"></h3>
  </div>
  <div class="revocation__header-col col-12">
    <p class="revocation__description"
       [innerHTML]="translationService.getTranslation('revocation_description')"></p>
  </div>
</div>
<div class="revocation__content row">
  <div class="revocation__errors col-12">
    <app-general-errors [errors]="errorsArr"></app-general-errors>
    <div class="revocation__spinner" style="text-align: center;" *ngIf="isLoadingSub">
      <app-loading-spinner></app-loading-spinner>
    </div>
    <div class="revocation__no-subs"
         *ngIf="!isLoadingSub && subs.length === 0 && errorsArr.length === 0"
         [innerHTML]="translationService.getTranslation('intro_noSubs')">
    </div>
    <div class="row revocation__subs" id="revocationSubscriptions">
      <ng-container *ngIf="!isLoadingSub && subs.length > 0">
        <div class="col-12 col-md-6 col-lg-4 mt-4" *ngFor="let sub of subs">
          <mat-card class="revocation__sub-card" appearance="outlined">
            <div class="revocation__sub-row m-3">
              <div class="revocation__sub-info col-12">
                <mat-card-title class="revocation__sub-title">{{ sub.productDescription }}</mat-card-title>
                <mat-card-subtitle class="revocation__sub-id"
                                   *ngIf="sub.subId"
                                   [innerHTML]="translationService.getTranslation('order_id') + ': ' + sub.subId">
                </mat-card-subtitle>
                <mat-card-subtitle class="revocation__sub-edition"
                                   *ngIf="sub.variantDescription"
                                   [innerHTML]="translationService.getTranslation('order_edition') + ': ' + sub.variantDescription">
                </mat-card-subtitle>
                <mat-card-subtitle class="revocation__sub-period"
                                   *ngIf="sub.validDate"
                                   [innerHTML]="translationService.getTranslation('period') + ': ' +
                        (sub.validDate.validFrom | date: translationService.getTranslation('dateFormat')) + ' - ' +
                        ((sub.validDate.validUntil) ? (sub.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : translationService.getTranslation('subscription_endless'))">
                </mat-card-subtitle>
              </div>
              <div class="revocation__sub-actions col-12">
                <mat-card-actions class="revocation__actions card-actions">
                  <button ngSkipHydration mat-raised-button color="primary"
                          class="mt-2 revocation__new-btn"
                          (click)="onNewRevocation(sub)">
                    {{ translationService.getTranslation('button_new_revocation') }}
                  </button>
                </mat-card-actions>
              </div>
            </div>
          </mat-card>
        </div>
      </ng-container>
    </div>
  </div>
</div>
